<template>
  <div class="default-sidebar">
    <div class="sidebar-item" v-for="(tabsItem, tabsIndex) in tabsList" :key="tabsItem.name">
      <tabs
        v-show="!(tabsItem.name == '阅读数据' && booksCurrentSubAccount != '')"
        :tabsName="tabsItem.name"
        :tabsIndex="tabsIndex"
        :tabsComponent="tabsItem.component"
        :url="tabsItem.url"
        :isOpen="tabsItem.open"
        :subTabsList="tabsItem.subTabs"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import tabs from './components/tabs.vue'
import vips from '@api/vip'
export default {
  name: 'DefaultSidebar',
  data() {
    return {
      tabsList: [
        {
          name: '电子书刊',
          url: '/list',
          border: true,
          open: true,
          component: 'MyBooks',
          subTabs: [
            { name: '我的书刊', url: 'to', component: 'MyBooks', id: 1, upIndex: 0 },
            { name: '我的专辑', url: 'to', component: 'MyBookshelf', id: 2, upIndex: 0 },
            { name: '我的图书馆', url: 'to', component: 'MyBooklib', id: 3, upIndex: 0 },
            { name: '我的链接作品', url: 'to', component: 'MyLinkword', id: 4, upIndex: 0 },
            { name: '书刊默认效果', url: 'to', component: 'DefaultEdit', id: 5, upIndex: 0 }
          ]
        },
        {
          name: '数字报纸',
          url: '/list',
          border: true,
          open: true,
          component: 'MyPapers',
          subTabs: [
            { name: '我的数字报', url: 'to', component: 'MyPapers', id: 1, upIndex: 1 },
            { name: '报纸文章库', url: 'to', component: 'PaperArticleLib', id: 2, upIndex: 1 },
            // { name: 'AI视频报道', url: 'to', component: 'PaperAiVideos', id: 3, upIndex: 1 },
            { name: '报纸管理', url: 'to', component: 'PaperManagement', id: 4, upIndex: 1 },
            { name: '我的专题', url: 'to', component: 'MyTopics', id: 5, upIndex: 1 }
          ]
        },
        {
          name: '内容运营',
          border: true,
          open: true,
          url: '/list',
          component: 'ChargeManagement',
          subTabs: [
            {
              name: '鉴权阅读管理',
              url: 'to',
              id: 1,
              upIndex: 2,
              component: 'ChargeManagement'
            },
            {
              name: '问卷数据',
              url: 'to',
              id: 2,
              upIndex: 2,
              component: 'QuestionnaireData'
            },
            {
              name: '阅读数据',
              url: '/statistics/index.html#/?from=ebook',
              border: false,
              open: false,
              subTabs: [
                { name: '访问统计', url: 'to', component: '' },
                { name: '访客统计', url: 'to', component: '' },
                { name: '阅读统计', url: 'to', component: '' }
              ]
            }
          ]
        },
        {
          name: '视频推荐',
          url: '/video',
          border: true,
          open: false,
          component: 'VideoRecommendation'
        }
      ],
      locationUrl: window.location.href,
      urlMaps: [
        {
          param: 'to=book',
          index: 0,
          subIndex: 0,
          management: 'MyBooks'
        },
        {
          param: 'to=edit',
          index: 0,
          subIndex: 4,
          management: 'DefaultEdit'
        },
        {
          param: 'to=album',
          index: 0,
          subIndex: 1,
          management: 'MyBookshelf'
        },
        {
          param: 'to=lib',
          index: 0,
          subIndex: 2,
          management: 'MyBooklib'
        },
        {
          param: 'to=link',
          index: 0,
          subIndex: 3,
          management: 'MyLinkword'
        },
        {
          param: 'to=paper',
          index: 1,
          subIndex: 0,
          management: 'MyPapers'
        },
        {
          param: 'to=PaperArticle',
          index: 1,
          subIndex: 1,
          management: 'PaperArticleLib'
        },
        {
          param: 'to=baozhi',
          index: 1,
          subIndex: 2,
          management: 'PaperManagement'
        },
        {
          param: 'to=topic',
          index: 1,
          subIndex: 2,
          management: 'MyTopics'
        },
        {
          param: 'to=questionnaire',
          index: 2,
          subIndex: 1,
          management: 'QuestionnaireData'
        },
        {
          param: 'to=charge',
          index: 2,
          subIndex: 0,
          management: 'ChargeManagement'
        },
        {
          param: 'to=invoice',
          index: 3,
          subIndex: 0,
          management: 'InvoiceManagement'
        },
        {
          param: 'to=video',
          index: 3,
          subIndex: -1,
          management: 'VideoRecommendation'
        }
      ]
    }
  },
  computed: {
    ...mapState('manage', ['booksCurrentSubAccount'])
  },
  mounted() {
    if (this.$route.params.to) {
      const param = `to=${this.$route.params.to}`
      if (param === 'to=paper') {
        document.title = '数字报纸'
      }
      this.urlMaps.forEach((item) => {
        if (item.param === param) {
          this.$store.commit('manage/UPDATE_SIDEBAR_INFO', {
            index: item.index,
            subIndex: item.subIndex,
            component: item.management
          })
        }
      })
      return
    }
    //有可能是从阅读数据跳转过来，打开时需要获取参数指定跳转
    this.urlMaps.forEach((item) => {
      if (this.locationUrl.indexOf(item.param) > -1) {
        this.$store.commit('manage/UPDATE_SIDEBAR_INFO', {
          index: item.index,
          subIndex: item.subIndex,
          component: item.management
        })
        window.location.href = this.locationUrl.slice(0, this.locationUrl.indexOf(`?${item.param}`))
      }
    })
  },
  async created() {
    await vips.getAuthenUserByLoginName().then((res) => {
      if (res.data && res.data.status === 0) {
        let tabItem = {
          name: '开票申请',
          url: 'to',
          id: 3,
          upIndex: 2,
          component: 'InvoiceManagement'
        }
        this.tabsList[2].subTabs.splice(1, 0, tabItem)
      }
    })
  },
  components: {
    tabs
  }
}
</script>

<style lang="scss" scoped>
.default-sidebar {
  min-width: 225px;
  border-top: solid 2px #ebebeb;
  z-index: 999;
  .sidebar-item {
    background-color: #fafafa;
    border-bottom: 1px solid #e9e9e9;
    cursor: pointer;
  }
}
</style>
